import type {CreatePaymentWayRequest} from '@rocket-ui/lk-api';
import {extractAccountDigits} from './accountNumber';
import {extractBikDigits} from './bik';
import type {SelectedBank} from './selectedBank';

type BuildAccountPaymentWayParams = {
	bik: string;
	account: string;
	selectedBank: SelectedBank | null;
	isPrimary?: boolean;
};

export function buildAccountPaymentWayRequest({
	bik,
	account,
	selectedBank,
	isPrimary = false,
}: BuildAccountPaymentWayParams): CreatePaymentWayRequest | null {
	const resolvedBik = selectedBank?.bik ?? extractBikDigits(bik);
	const resolvedAccount = extractAccountDigits(account);

	if (!resolvedBik || !resolvedAccount) {
		return null;
	}

	return {
		type: 'executor_account',
		bik: resolvedBik,
		account: resolvedAccount,
		isPrimary,
	};
}
